import Background from '../modules/background.js';
import Loader from '../modules/loader.js';
import DealerSearch from '../modules/dealer-search.js';
import DealerResults from '../modules/dealer-results.js';
import DealerLastViewed from '../modules/dealer-last-viewed.js'

export default class SearchView {
    constructor(parent, router) {
        this.router = router;
        this.el = parent.el.querySelector('.fad-search');
        this.loader = new Loader(this, router);
        this.background = new Background(this, router);
        this.lastViewed = new DealerLastViewed(this, router);
        this.results = new DealerResults(this, router);
        this.search = new DealerSearch(this, router);
    }

    show() {
        this.el.classList.remove('hide');
        this.search.show();
    }

    hide() {
        this.el.classList.add('hide');
    }
}
